import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AuthProvider } from '@/auth/AuthProvider';
import { App } from './App';
import { TeamsConfigPage } from '@/teams/TeamsConfigPage';
import '@/i18n';
import '@fortawesome/fontawesome-free/css/all.min.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,   // 5 min — avoids re-fetching on every mount
      retry: 1,
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

const isConfigRoute = /^\/config\/?$/.test(window.location.pathname);

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    {isConfigRoute ? (
      <TeamsConfigPage />
    ) : (
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    )}
  </React.StrictMode>
);
